import styled from 'styled-components'
import { SIZES } from '../../constants/index'

export default styled.span`
  &.video, &.gallery {
    background: url(${STATICS_PATH}images/video/play-photo-sprite.png);
    bottom: 13px;
    display: none;
    height: 32px;
    left: 13px;
    position: absolute;
    width: 32px;
  }

  &.video {
    background-position: 0 -106px;
  }

  &.gallery {
    height: 24px;
    background-position: 0 -392px;
  }
  
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    &.video, &.gallery {
      display: block;
    }
  
    &.video {
      height: 24px;
      background-position: 0 -172px;
    }
  }
  
  &.online {
    background-color: #f44336;
    bottom: 0;
    color: #fff;
    display: inline-block;
    font-size: 10px;
    font-weight: bold;
    height: 20px;
    left: 0;
    line-height: 20px;
    padding: 0 4px;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
  }

  &.online::before {
    content: '● ONLINE'
  }

  &.online.small {
    font-size: 8px;
    height: 15px;
    line-height: 15px;
  }

  &.online.big {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
  }

  &.online.inline {
    display: inline-block;
    font-size: 10px;
    height: 18px;
    line-height: 18px;
    margin-left: 10px;
    margin-right: 0;
    position: unset;
    vertical-align: top;
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      position: relative;
      float: right;
    };
  }
`
